import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a68790de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-section" }
const _hoisted_2 = { class: "custom-control custom-checkbox" }
const _hoisted_3 = {
  class: "custom-control-label",
  for: "terms-of-purchase"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" I am legally allowed to sell these products, which to the best of my knowledge, comply with any applicable FDA restrictions. ")
const _hoisted_5 = { class: "action-wrap" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "custom-control-input",
            id: "terms-of-purchase",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fdaSellerApproved) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.fdaSellerApproved]
          ]),
          _hoisted_4
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "tabs-actions btn btn-secondary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeTab('prev')))
      }, "Prev"),
      _createElementVNode("button", {
        disabled: _ctx.disabled,
        class: "tabs-actions btn btn-secondary",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createItem && _ctx.createItem(...args)))
      }, "Finish", 8, _hoisted_6)
    ])
  ], 64))
}